// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".term-list-module--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; }\n  .term-list-module--layout .term-list-module--list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px; }\n", ""]);
// Exports
module.exports = exports;
